import { z } from 'zod';
// Login
export const LoginSchema = z.object({
    email: z.string().email('Email inválido'),
    password: z.string().min(8, 'Senha deve ter no mínimo 8 caracteres'),
    tenantId: z.string().uuid().optional(),
});
// Register
export const RegisterSchema = z.object({
    name: z.string().min(2, 'Nome deve ter no mínimo 2 caracteres'),
    email: z.string().email('Email inválido'),
    password: z
        .string()
        .min(8, 'Senha deve ter no mínimo 8 caracteres')
        .regex(/[A-Z]/, 'Senha deve conter pelo menos uma letra maiúscula')
        .regex(/[0-9]/, 'Senha deve conter pelo menos um número'),
    clinicName: z.string().min(2, 'Nome da clínica deve ter no mínimo 2 caracteres').optional(),
    // Story 28.22 (PV-15): telefone (WhatsApp) capturado no cadastro. Opcional —
    // não bloqueia o registro, mas quando enviado é persistido em User.phone.
    phone: z.string().trim().min(8, 'Telefone inválido').max(32).optional(),
});
// Refresh Token
export const RefreshTokenSchema = z.object({
    refreshToken: z.string().min(1, 'Refresh token é obrigatório'),
});
// Forgot Password
export const ForgotPasswordSchema = z.object({
    email: z.string().email('Email inválido'),
});
// Reset Password
export const ResetPasswordSchema = z.object({
    token: z.string().min(1, 'Token é obrigatório'),
    password: z
        .string()
        .min(8, 'Senha deve ter no mínimo 8 caracteres')
        .regex(/[A-Z]/, 'Senha deve conter pelo menos uma letra maiúscula')
        .regex(/[0-9]/, 'Senha deve conter pelo menos um número'),
});
// Change Password
export const ChangePasswordSchema = z.object({
    currentPassword: z.string().min(1, 'Senha atual é obrigatória'),
    newPassword: z
        .string()
        .min(8, 'Nova senha deve ter no mínimo 8 caracteres')
        .regex(/[A-Z]/, 'Nova senha deve conter pelo menos uma letra maiúscula')
        .regex(/[0-9]/, 'Nova senha deve conter pelo menos um número'),
});
//# sourceMappingURL=auth.js.map